export default {
    "/": {
        "title": "Taoify - Платформа для создания независимых онлайн-магазинов | Китайские товары, продажа по всему миру",
        "desc": "Taoify объединяет создание сайта, перевод, размещение товаров, логистику, прием платежей и маркетинг в одном интерфейсе: 18 AI-помощников помогают вам, открытие магазина на 20 языках, китайские товары продаются по всему миру."
    },
    "/feature": {
        "title": "Функции · Все, что нужно для открытия магазина, на одной странице · Taoify",
        "desc": "Создание сайта, перевод, размещение, отправка, прием платежей, привлечение клиентов — Taoify объединяет 15 необходимых модулей в одном интерфейсе, без необходимости использования множества внешних инструментов."
    },
    "/ai-staff": {
        "title": "AI-помощники · 18 AI-помощников, самые занятые — те, кто занимается привлечением трафика · Taoify",
        "desc": "Из 18 AI-помощников 5 специализируются на решении проблемы «никто не приходит»: 12 проверок состояния магазина, 30-дневный маркетинговый план, адаптация одного товара для 9 каналов, автоматические маркетинговые письма для возврата покупателей."
    },
    "/logistics": {
        "title": "Кросс-граничные перевозки · От вас до клиента · Taoify",
        "desc": "Первая миля, таможенное оформление, основная перевозка, доставка до двери, три маршрута на выбор в зависимости от типа груза и сроков. Уже подключены YunExpress, Yanwen, 4PX, все операции, включая трекинг и обработку исключительных ситуаций, в одном интерфейсе."
    },
    "/payment": {
        "title": "Прием платежей и расчеты · Как удобно вашим клиентам · Taoify",
        "desc": "Подключение PayPal, Stripe, кредитных карт, Alipay. Принимайте платежи в иностранной валюте, выводите в юанях, расчеты T+7, комиссии и сроки зачисления указаны явно."
    },
    "/pricing": {
        "title": "Цены · Подписка + прогрессивная комиссия · Taoify",
        "desc": "Оплата магазина по подписке: базовая версия $15/месяц, стандартная версия $29/месяц, флагманская версия $59/месяц, скидки при оплате за квартал или год. Комиссия за транзакции зависит от месячного оборота, минимальная 3%."
    },
    "/cases": {
        "title": "Кейсы продавцов · Они тоже это делают · Taoify",
        "desc": "Продавцы из Иу (бижутерия), Шэньчжэня (3C), Гуанчжоу (одежда), а также из Германии, США и Франции — шесть человек, шесть разных стартовых точек, один подход."
    },
    "/sign-up": {
        "title": "Открытие магазина - бесплатная регистрация на Taoify",
        "desc": "Создайте брендовый интернет-магазин за 10 минут без кодирования. Полный функционал в рамках пробного периода. Начните свое путешествие в кросс-граничной электронной коммерции, зарегистрировавшись на Taoify прямо сейчас."
    },
    "/for-china-sellers": {
        "title": "Для китайских продавцов · Выберите товары и установите цены, остальное сделаем мы · Taoify",
        "desc": "Платформа берет на себя все хлопоты: от создания сайта до ответов клиентам. Предлагаем подписку + гибкую комиссию (от 3%)."
    },
    "/for-global-sellers": {
        "title": "Для зарубежных продавцов: выбирайте товары с полок Китая, продавайте у себя в магазине · Taoify",
        "desc": "Без необходимости держать запасы: выбирайте товары из китайской цепочки поставок, отправка напрямую из китайского склада после заказа клиента. BuyLink позволяет превратить ссылки 1688 и Taobao в ваши товары."
    },
    "/template-index": {
        "title": "Рынок шаблонов - профессиональные темы для сайтов от Taoify",
        "desc": "Профессиональные темы для сайтов, подходящие для любых проектов. Бесплатное использование множества тематических шаблонов, возможность настройки бренда и функций под свои нужды."
    },
    "/question": {
        "title": "Центр помощи · Сначала ищите здесь · Taoify",
        "desc": "Вопросы, связанные с открытием, оформлением, выкладкой товаров, логистикой, платежами, маркетингом, правами доступа — все организовано по категориям. Если не нашли ответ, создайте тикет."
    },
    "/about-us": {
        "title": "О нас · Taoify · Наша миссия",
        "desc": "Taoify — это интегрированная платформа для создания сайтов, предназначенная для международных продавцов: создание сайта, перевод, размещение товаров, логистика, прием платежей и маркетинг — все в одном интерфейсе."
    },
    "/privacy-policy": {
        "title": "Политика конфиденциальности · Taoify",
        "desc": "Как Taoify собирает, использует, хранит и защищает ваши личные данные, а также какие права вы имеете в отношении своих данных."
    },
    "/terms-service": {
        "title": "Условия использования · Taoify",
        "desc": "Условия и положения использования платформы Taoify: аккаунты, магазины, заказы, расчеты и распределение ответственности."
    },
    "/consumer-agreement": {
        "title": "Политика возврата · Taoify",
        "desc": "Правила возврата и послепродажного обслуживания на платформе Taoify: условия подачи заявки, сроки обработки и способы получения средств."
    },
    "/user-agreement": {
        "title": "Пользовательское соглашение · Taoify",
        "desc": "Перед регистрацией и использованием Taoify ознакомьтесь с правилами регистрации, ведения магазина и условиями предоставления услуг платформы."
    }
}
